import slice from "./slice";

export const { resetState, setSelectedDrone, setSidebarType, setWaypoints, setEditableRoute, setHoveredDrone, setTerrainMode } = slice.actions;